// ตัวแปลงค่าสำหรับเอกสารรับสมัคร
//
// ระบบเดิมทำการแปลงพวกนี้ที่ฝั่ง server (registerController.getRegister) แล้วส่งค่า
// ที่ถูกหั่นเป็น array มาให้หน้าเว็บเลย ทำให้ endpoint เดียวกันใช้กับหน้าอื่นไม่ได้
// ที่นี่ API คืนแถวดิบตามตาราง แล้วมาแปลงตอนจะพิมพ์เท่านั้น

const THAI_MONTHS = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
]

// วันที่ -> [วัน, ชื่อเดือนไทย, ปี พ.ศ.] เพื่อเติมลงช่อง "วันที่ ... เดือน ... พ.ศ. ..."
export const dateParts = (value) => {
  if (!value) return null
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null
  return [d.getDate(), THAI_MONTHS[d.getMonth()], d.getFullYear() + 543]
}

// หั่นชื่อเต็มเป็น [คำนำหน้า, ชื่อ, นามสกุล] ตามที่แบบฟอร์มแยกช่อง "ชื่อ" กับ "สกุล"
// ชื่อในฐานข้อมูลไม่ได้สะอาดเสมอ บางแถวไม่มีคำนำหน้า บางแถวมีช่องว่างซ้อน
// จึงคืนค่าที่ปลอดภัยเสมอแทนที่จะพังเวลา index ไม่ครบ
export const nameParts = (fullName) => {
  const parts = String(fullName || '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return { prefixFirst: '', last: '', full: '' }
  if (parts.length === 1) return { prefixFirst: parts[0], last: '', full: parts[0] }
  if (parts.length === 2) return { prefixFirst: parts[0], last: parts[1], full: parts.join(' ') }
  // 3 ส่วนขึ้นไป: คำนำหน้า + ชื่อ อยู่ช่องแรก ที่เหลือเป็นนามสกุล
  return {
    prefixFirst: `${parts[0]} ${parts[1]}`,
    last: parts.slice(2).join(' '),
    full: parts.join(' '),
  }
}

// เลขบัตร/รหัสประจำบ้าน -> array ของตัวเลขทีละหลัก สำหรับใส่ในช่องสี่เหลี่ยม
export const digits = (value, length) => {
  const chars = String(value || '').replace(/\D/g, '').split('')
  return Array.from({ length }, (_, i) => chars[i] || '')
}

export const CLASS_LABEL_DOC = {
  a1: 'อ. 1', a2: 'อ. 2', a3: 'อ. 3',
  p1: 'ป. 1', p2: 'ป. 2', p3: 'ป. 3', p4: 'ป. 4', p5: 'ป. 5', p6: 'ป. 6',
  h1: 'ม. 1', h2: 'ม. 2', h3: 'ม. 3', h4: 'ม. 4', h5: 'ม. 5', h6: 'ม. 6',
}

export const classLabel = (code) => CLASS_LABEL_DOC[code] || code || ''

// ระบบเดิมเก็บ '0' แทน "ตาดีกา" ในช่องชั้นศาสนาที่จบ
export const islamicClassLabel = (value) => (value === '0' ? 'ตาดีกา' : value || '')

export const money = (value) =>
  value === null || value === undefined || value === '' ? '' : Number(value).toLocaleString('en-US')

// ปีการศึกษาที่พิมพ์บนหัวเอกสาร
//
// ระบบเดิมฮาร์ดโค้ดไว้ในไฟล์ (มี commit "adjust year to 2568", "edit register year in doc to 2568"
// ทุกปี) ที่นี่ใช้ปีที่สมัครจริงของแถวนั้น เพื่อให้พิมพ์ใบเก่าย้อนหลังแล้วปีไม่เพี้ยน
// และไม่ต้องกลับมาแก้โค้ดทุกปี
export const admissionBeYear = (regisDate) => {
  const parts = dateParts(regisDate)
  return parts ? parts[2] : new Date().getFullYear() + 543
}
